<mat-card appearance="outlined" class="special-features__subsection subsection">
  <div class="subsection__header">
    <span
      class="subsection__header-item header-item"
      [ngClass]="{
        'header-item--active': isActive,
        'header-item--inactive': !isActive,
      }">
      <mat-icon id="circle">circle</mat-icon>
    </span>
    <span class="subsection__header-item"
      ><h4>{{ title }}</h4></span
    >
    <span
      class="subsection__header-item header-item"
      [ngClass]="{
        'header-item--active': isActive,
        'header-item--inactive': !isActive,
      }"
      ><h4>{{ isActive ? 'active' : 'inactive' }}</h4></span
    >
    <span class="subsection__header-item header-item subsection__toggle">
      <mat-slide-toggle
        [disabled]="true"
        (toggleChange)="toggleChange()"
        [checked]="isActive"
        color="primary"></mat-slide-toggle>
    </span>
  </div>
</mat-card>
